import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function EmployeeDetails() {
  const [employeeData, setEmployeeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const employeeName = sessionStorage.getItem('name');

    if (!employeeName) {
      setError('No employee name found in session storage');
      setLoading(false);
      return;
    }

    const fetchEmployeeDetails = async () => {
      try {
        const response = await fetch(`https://api.assetview.warrantyindia.com/employeename?q=${employeeName}`);
        if (!response.ok) {
          throw new Error('Failed to fetch employee details');
        }
        const data = await response.json();
        setEmployeeData(data[0]);
        sessionStorage.setItem('email', data[0].Official_Email);
        sessionStorage.setItem('mobile', data[0].mobile);
        sessionStorage.setItem('areaoffice', data[0].areaoffice);
        sessionStorage.setItem('address', data[0].address);
        sessionStorage.setItem('employeeId', data[0].Employee_ID); // ✅ Save Employee ID
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchEmployeeDetails();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  function SearchPage() {
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('email');
    sessionStorage.removeItem('address');
    sessionStorage.removeItem('areaoffice');
    sessionStorage.removeItem('mobile');
    sessionStorage.removeItem('employeeId'); // ✅ Clear Employee ID on reset
    navigate('/employeesearch');
    window.location.reload();
  }

  return (
    <div style={{ marginBottom: '45px' }}>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '40px', alignItems: 'center' }}>
        <h1 style={{ textAlign: 'center' }}>Employee Details</h1>
        <button style={{ padding: '7px', background: 'red' }} onClick={SearchPage}>
          Search For Another Employee
        </button>
      </div>
      {employeeData ? (
        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '20px' }}>
          <p><strong>Employee ID:</strong> {employeeData.Employee_ID}</p> {/* ✅ Display Employee ID */}
          <p><strong>Name:</strong> {employeeData.employeeName}</p>
          <p><strong>Email:</strong> {employeeData.email}</p>
          <p><strong>Official Email:</strong> {employeeData.Official_Email}</p>
          <p><strong>Area Office:</strong> {employeeData.areaoffice}</p>
          <p><strong>Mobile:</strong> {employeeData.mobile}</p>
          <p><strong>Address:</strong> {employeeData.address}</p>
        </div>
      ) : (
        <div>No data found</div>
      )}
    </div>
  );
}